// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   Confirmation Modal
   
   Design System: Uses CSS variables from colors.css
   - Flat surfaces with borders (no gradients)
   - Minimal/no corner radii
   - Compact and simple
   ====================== */

.confirmation-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2100;
}

.confirmation-card {
  width: min(340px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: confirmationModalIn 0.15s ease;
}

@keyframes confirmationModalIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 640px) {
  .confirmation-card {
    padding: 14px;
  }

  .confirmation-header h2 {
    font-size: 14px;
  }
}

.confirmation-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.confirmation-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.confirmation-header p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.45;
}

.confirmation-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 4px;
}

.confirmation-primary {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease;
  font-family: inherit;
}

.confirmation-primary:hover {
  background: var(--color-bg-user-bubble);
}

.confirmation-primary:active {
  background: var(--color-bg-input);
}

.confirmation-secondary {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family: inherit;
}

.confirmation-secondary:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.confirmation-destructive {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease;
  font-family: inherit;
}

.confirmation-destructive:hover {
  background: var(--color-bg-user-bubble);
}

.confirmation-destructive:active {
  background: var(--color-bg-input);
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmationModal.css"],"names":[],"mappings":"AAAA;;;;;;;2BAO2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* ======================\n   Confirmation Modal\n   \n   Design System: Uses CSS variables from colors.css\n   - Flat surfaces with borders (no gradients)\n   - Minimal/no corner radii\n   - Compact and simple\n   ====================== */\n\n.confirmation-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2100;\n}\n\n.confirmation-card {\n  width: min(340px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: confirmationModalIn 0.15s ease;\n}\n\n@keyframes confirmationModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 640px) {\n  .confirmation-card {\n    padding: 14px;\n  }\n\n  .confirmation-header h2 {\n    font-size: 14px;\n  }\n}\n\n.confirmation-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.confirmation-header h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.confirmation-header p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.confirmation-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.confirmation-primary {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  font-family: inherit;\n}\n\n.confirmation-primary:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.confirmation-primary:active {\n  background: var(--color-bg-input);\n}\n\n.confirmation-secondary {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  font-family: inherit;\n}\n\n.confirmation-secondary:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.confirmation-destructive {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-weight: 600;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  font-family: inherit;\n}\n\n.confirmation-destructive:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.confirmation-destructive:active {\n  background: var(--color-bg-input);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
